import { render, staticRenderFns } from "./IconSelectorModal.vue?vue&type=template&id=98a3f89c"
import script from "./IconSelectorModal.vue?vue&type=script&lang=js"
export * from "./IconSelectorModal.vue?vue&type=script&lang=js"
import style0 from "./IconSelectorModal.vue?vue&type=style&index=0&id=98a3f89c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports